import styled from '@emotion/styled';

import { BetStatus, BetType } from '@/lib/apollo/types/gen/graphql';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Table = styled.table(() =>
  mq({
    width: '100%',
    border: 'solid',
    borderColor: defaultTheme.border.color.black,
    borderWidth: '1px 0 1px 0',
  }),
);

export const TableRow = styled.tr((props: { betType: BetType }) =>
  mq({
    borderBottom:
      props.betType !== BetType.QuinellaPlace &&
      `1px solid ${defaultTheme.border.color.black}`,
    fontSize: [
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
    ],
  }),
);

export const TableHeader = styled.th(() =>
  mq({
    width: '80px',
    textAlign: 'center',
    fontWeight: 'inherit',
    backgroundColor: defaultTheme.background.mediumGray,
    padding: '10px',
  }),
);

export const TableData = styled.td(
  (props: { betType: BetType; betStatus: BetStatus }) =>
    mq({
      display: 'flex',
      justifyContent: [BetStatus.AllReturn, BetStatus.DeadHeatOver].includes(
        props.betStatus,
      )
        ? 'center'
        : 'space-between',
      borderBottom:
        props.betType === BetType.QuinellaPlace &&
        `1px solid ${defaultTheme.border.color.lightGray}`,
      padding: '10px',
    }),
);

export const SetNumberText = styled.span(() =>
  mq({
    fontWeight: 'bold',
    marginRight: '10px',
  }),
);

export const FlexBox = styled.span(() =>
  mq({
    display: 'flex',
  }),
);

export const RefundAmount = styled.span(() =>
  mq({
    fontWeight: 'bold',
  }),
);

export const TextBold = styled.span(() =>
  mq({
    fontWeight: 'bold',
  }),
);
